<template>
  <div class='grass-search-container'>
   <search  @onSearch="onSearch" :isTrim="isTrim"></search>
   <!-- 搜索历史内容 -->
   <div class="search-hot" id="history" v-if="historyList.length > 0">
     <div class="search-title">
       <div class="left-title">搜索历史</div>
       <div class="delete-btn" @click="deleteHistory"></div>
     </div>
     <div class="search-item-wrapper">
       <div id="search-hot-item" v-show="historyList.length > 0" v-for="(item,index) in historyList" :key="index" @click="onSearch(item)">{{item.length > 10 ? item.slice(0,10) + '...' : item}}</div>
     </div>
   </div>
   <!-- 搜索发现内容 -->
   <div class="search-hot" id="searchmove" v-if="hotList.length>0">
     <div class="left-title-look">搜索发现</div>
     <div class="search-hot-wrapper" v-for="(item,index) in hotList" :key="index" @click="onSearch(item.content),sensorsFn(item.content)">
       <span></span>
       <div class="hot-item" >{{item.content}}</div>
     </div>
   </div>
  </div>
</template>

<script>
import search from '@/components/community/search/index.vue';
import {uniqueArr, Debounce} from '../../../assets/js/common';
import API from '@/utils/axiosApi/communityApi';
import { xmhh5CommunityClick_fn, BuiedPointClick_Fn } from "@/assets/js/BuriedPointEvent";
  export default {
    components: { search },
    data () {
      return {
        historyList: localStorage.getItem('grassHistory') && JSON.parse(localStorage.getItem('grassHistory')) || [] ,
        hotList:[],
        placeholder: "",
        isTrim: false,
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      // 搜索发现埋点
      sensorsFn(value){
        xmhh5CommunityClick_fn("xmhh5CommunityClick", {
          xmhh5_Community_Find_Click: value,
        })
        BuiedPointClick_Fn("xmhh5CommunityFindClick", {
          xmhh5_Community_Find_Id_Click: value,
        })
      },
      // 获取搜索发现词
      getSearchHotData(){
        API.searchLook({}, {columnId:12 }, (res)=>{
           this.hotList = res.data
        })
      },
      /**
       * 搜索文案不为空
       * 搜索文案为空：打空格， 没输入
       */
      onSearch:Debounce(function(value, status){
       if(value != ""){
        this.historyList.unshift(value);
        this.$router.push({path: "/grassSearch/" + value});
       }else{
        //输入空格
        if( (value === "" && status)  ||  this.placeholder === "搜索"){
          this.$toast({
            message: "请输入搜索内容",
            duration: 2000
          });
        } else if (!status && this.placeholder !== "搜索" ){
          this.historyList.unshift(this.placeholder);
          this.$router.push({path: "/grassSearch/" + this.placeholder});
        }
       }
        this.historyList = uniqueArr(this.historyList)
        this.isTrim = false
        localStorage.setItem("grassHistory", JSON.stringify(this.historyList))
      }),
      deleteHistory(){
        const that = this
        this.$dialog
        .confirm({
          message: "是否清空全部搜索记录？",
          confirmButtonText: "确定删除",
          confirmButtonColor: "#D4A437",
          cancelButtonColor: "#333",
        })
        .then(() => {
          $(".his").fadeOut(100);
          $("#history").fadeOut(500)
          setTimeout(()=>{
            localStorage.removeItem("grassHistory");
            this.historyList = [];
          },300)
        })
        .catch(() => {
          // on cancel
        });
      },
      },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {
      this.$store.commit("changeIncludes", ["communityIndex", "communityList"]);
      this.getSearchHotData()
      this.placeholder = this.$route.query.hot  ? this.$route.query.hot : "搜索"
      BuiedPointClick_Fn("xmhh5CommunityallPageView", {
       xmhh5_Community_Page_Name: "搜索页"
      })
    },
  }
</script>
<style lang='less' scoped>
.grass-search-container{
  height: 100vh;
  background: #FFFFFF;
}
.search-hot{
  margin-top: 28px;
  padding: 0 12px;
  .search-title{
    display: flex;
    justify-content: space-between;
    .delete-btn{
      background-image: url('../../../assets/images/community/clear.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      width: 22px;
      height: 22px;
    }
    .left-title{
      // height: 21px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      // line-height: 21px;
    }
  }
  .search-item-wrapper{
    width: 100%;
    max-height: 72px;
    min-height: 36px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    #search-hot-item{
      background: #F8F8F8;
      border-radius: 16px;
      padding: 0px 12px;
      margin-top: 8px;
      height: 28px;
      line-height: 28px;
      margin-right: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
}
.left-title-look{
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FF4892;
  line-height: 20px;
  margin-bottom: 2px;
}
.search-hot-wrapper{
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #CCCCCC;
  }
  .hot-item{
    margin-left: 12px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
#searchmove{
  // height: 100vh;
  background-color: #FFFFFF;
}
</style>